<template>
  <div>
    <div class="row header-dashboard-custom">
      <div class="col-12" style="margin-bottom: 10px; margin-top: 10px;">
        <!-- ✅ thêm @click-item -->
        <StatsCards :items="stats" @click-item="onClickStatsCard" />
      </div>
    </div>

    <!-- ✅ Dialog hiển thị danh sách biển số xe -->
    <Dialog
      :header="dialog_plate_title"
      :visible.sync="showDialogPlate"
      :modal="true"
      :style="{ width: '720px' }"
      :contentStyle="{ overflow: 'hidden' }"
    >
      <div class="car-wrap">
        <div v-if="loadingPlate" class="car-loading">Loading...</div>

        <div v-else>
          <div v-if="plateList.length === 0" class="car-empty">Empty data</div>

          <div v-else class="car-list">
            <div
              v-for="r in plateList"
              :key="r.id"
              class="car-item"
              :class="{ 'has-note': r.latest_note && r.latest_note.trim() }"
            >
              <!-- LEFT -->
              <div class="car-left">
                <div class="lp" :title="r.license_plate_number">
                  <span class="lp-dot"></span>
                  <span class="lp-text">{{ r.license_plate_number }}</span>
                  <span class="lp-dot"></span>
                </div>
              </div>

              <!-- RIGHT -->
              <div class="car-right">
                <div class="car-right-header">
                  <span class="car-right-title">Latest note</span>
                  <span class="car-date" :class="{ empty: !r.latest_note_at }">
                    {{ formatNoteDate(r.latest_note_at) }}
                  </span>

                  <!-- ✅ nút ghi chú theo từng item -->
                  <Button
                    class="p-button-sm p-button-outlined car-btn-note"
                    icon="pi pi-plus"
                    label="Add note"
                    @click="toggleEditNote(r)"
                  />
                </div>

                <div
                  class="car-note"
                  :class="{ empty: !(r.latest_note && r.latest_note.trim()) }"
                  :title="r.latest_note || ''"
                >
                  {{ (r.latest_note && r.latest_note.trim()) ? r.latest_note : '-' }}
                </div>

                <!-- ✅ textbox nhập ghi chú -->
                <div v-if="editingNoteId === r.id" class="car-add-note">
                  <div class="car-add-note-head">
                    <span class="car-add-note-title">Enter new note</span>
                  </div>

                  <div class="car-add-note-body">
                    <Textarea
                      v-model="noteDrafts[r.id]"
                      :autoResize="true"
                      rows="2"
                      placeholder="Enter note..."
                      class="car-add-note-textarea"
                    />

                    <div class="car-add-note-btns">
                      <Button
                        class="p-button-sm"
                        icon="pi pi-check"
                        label="Save"
                        @click="submitNote(r)"
                        :disabled="savingNote || !(noteDrafts[r.id] && noteDrafts[r.id].trim())"
                        :loading="savingNote"
                      />
                      <Button
                        class="p-button-sm p-button-secondary p-button-outlined"
                        icon="pi pi-times"
                        label="Cancel"
                        @click="cancelEditNote(r)"
                        :disabled="savingNote"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- ACTION -->
              <div class="car-action">
                <span class="dot">⋮</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>







    <div class="payment-history-header">
      Payment History
    </div>
    <div class="up-and-down-payment">
      <div class="incoming-down">
        <img class="icon-down-up" src="/assets/layout/images/down-arrow.svg" alt="Car Loan">
        Incoming: <div class="amount-incoming">{{formatIncoming(incoming)}}</div>
      </div>
      <div class="outcoming-up">
        <img class="icon-down-up" src="/assets/layout/images/up-arrow.svg" alt="Car Loan">
        Outgoing: <div class="amount-outgoing">{{ formatIncoming(outgoing) }}</div>
      </div>
    </div>

    <DataTable
      :value="listDataService"
      :lazy="true"
      class="p-datatable-responsive"
      selectionMode="single"
      data-key="id"
      @page="onPage($event)"
      :paginator="pagination"
      :totalRecords="totalRecords"
      :rows="paginationRows"
      :loading="loading"
      :first="firstRecordIndex"
      :scrollable="(scrollHeight !== '' ? true : false) "
      :scrollHeight="scrollHeight"
      :autoLayout="true"
      filterMatchMode="startsWith"
      @row-select="onRowSelect"
      :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
      :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
      :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
    >
      <Column
        v-for="c in model.getDisplayFields()"
        :key="c.key"
        :field="getField(c)"
        :header="getLabel(c)"
        :ref="getField(c)"
        :filterMatchMode="getFilterMatch(c)"
        :sortable="getSortable(c)"
        :bodyClass="(c.class ? 'txt-' + c.class : '')"
        :bodyStyle="getBodyStyle(c)"
        :headerStyle="getHeaderStyle(c)"
        :headerClass="(c.class ? 'txt-' + c.class : '')"
      >
        <template #body="slotProps">
          <img v-if="getType(c) == 'Image'" :src="getData(c, slotProps.data)" style="width: 40px; heigth: 40px" />
          <div v-else-if="c.type == 'Text'" v-html="getData(c, slotProps.data)" :style="(c.style ? c.style : '')"></div>
          <div v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'" v-html="getData(c, slotProps.data)"
            :style="(c.style ? c.style : '')"></div>
          <div v-else-if="getType(c) == 'CustomUrl' && view_club ==true" v-html="callbackCustomUrl(c, slotProps.data)"
            @click="redirectListClub(slotProps.data, $event)" :style="(c.style ? c.style : '')"></div>
          <div v-else-if="getType(c) == 'CustomUrl'" v-html="callbackCustomUrl(c, slotProps.data)"
            @click="redirectListClub(slotProps.data, $event)" :style="(c.style ? c.style : '')"></div>

          <Checkbox v-else-if="getType(c) == 'Checkbox'" v-model="slotProps.data[slotProps.column.field]" :binary="true"
            @change="onInputChange($event, slotProps.data, c)" />
          <div v-else>
            <div v-if="c.custom">
              <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge" />
              <div v-if="c.custom == 'SelectionText'" v-html="callbackDataSelect( c ,slotProps.data)"></div>
            </div>
            <span v-else v-html="getData(c, slotProps.data)"
              :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
          </div>
        </template>

        <template v-if="c.filter" #filter>
          <InputText
            v-if="c.filter.type == 'input'"
            type="text"
            v-model="filters[getField(c)]"
            class="p-column-filter"
            :placeholder="$CoreService.getFilterPlaceHolder(c)"
            @keyup="onFilter($event,c.filter.type,c.key)"
          />
          <Dropdown
            :key="countDropdown"
            v-if="c.filter.type == 'select'"
            v-model="filters[getField(c)]"
            :options="getFilterOptions(c.key)"
            :optionLabel="c.filter.optionLabel"
            :optionValue="c.filter.optionKey"
            :placeholder="$CoreService.getFilterPlaceHolder(c)"
            class="p-column-filter"
            :showClear="true"
            appendTo="body"
            @change="onFilter($event,c.filter.type,c.key)"
          >
            <template #option="slotProps">
              <div class="p-clearfix">
                <span :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)">
                  {{ slotProps.option[c.filter.optionLabel] }}
                </span>
              </div>
            </template>
          </Dropdown>

          <Calendar
            v-if="c.filter.type == 'DateRange'"
            :showOnFocus="false"
            :monthNavigator="true"
            :yearNavigator="true"
            :yearRange="yearRange"
            dateFormat="yy-mm-dd"
            :placeholder="$CoreService.getFilterPlaceHolder(c)"
            v-model="filters[getField(c)]"
            class="p-column-filter calendar-light-btn"
            :showIcon="true"
            selectionMode="range"
            appendTo="body"
            :showClear="true"
            :showButtonBar="true"
            @clear-click="onFilter($event,c.filter.type,c.key)"
            @date-select="onFilter($event,c.filter.type,c.key)"
            :manualInput="false"
            style="width: 200px;"
          />

          <Calendar
            v-if="c.filter.type == 'Date'"
            :showOnFocus="false"
            :monthNavigator="true"
            :yearNavigator="true"
            :yearRange="yearDOB"
            dateFormat="yy-mm-dd"
            :placeholder="$CoreService.getFilterPlaceHolder(c)"
            v-model="filters[getField(c)]"
            class="p-column-filter calendar-light-btn"
            :showIcon="true"
            selectionMode="single"
            appendTo="body"
            :showClear="true"
            :maxDate="new Date()"
            :showButtonBar="true"
            @clear-click="onFilter($event,c.filter.type,c.key)"
            @date-select="onFilter($event,c.filter.type,c.key)"
            :manualInput="false"
            style="width: 200px;"
          />
        </template>
      </Column>

      <template #empty>
        {{ $t('datatable.empty') }}
      </template>
      <template #loading>
        {{ $t('datatable.loading') }}
      </template>
    </DataTable>
  </div>
</template>

<script>
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";
import StatsCards from "@/components/StatsCards.vue";

export default {
  components: { StatsCards },
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
  },
  data() {
    return {
      filters: {},
      countDropdown: 0,
      pagination: true,
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT,
      scrollHeight: '',
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService: null,
      filtersCustom: [],
      lazyParams: {},
      page_transaction: null,
      firstRecordIndex: 0,
      yearRange: (new Date().getFullYear() - 100) + ":" + (new Date().getFullYear() + 100),
      yearDOB: (new Date().getFullYear() - 100) + ":" + new Date().getFullYear(),
      time_zone_local: moment.tz.guess(true),
      view_club: false,
      obj_data: { effective_date_range: null },
      total_renting_car: 0,
      total_car_rent_in_showroom: 0,
      total_car: 0,
      total_for_sell: 0,
      total_sold_out_sell: 0,
      total_processing: 0,
      total_complete_sell: 0,
      list_data_table: [],
      incoming: 0,
      outgoing: 0,
      data_filter: {},

      // ✅ dialog state
      showDialogPlate: false,
      dialog_plate_title: "Car list",
      loadingPlate: false,
      plateList: [],

      // ✅ note UI state (thêm mới)
      editingNoteId: null,
      noteDrafts: {},
      savingNote: false,
      ADD_NOTE_ENDPOINT: "/_api/dashboard/add_car_note",

      stats: [
        {
          key: "total",
          icon: require("@/assets/car-total.png"),
          total: 0,
          text: "Total Car",
          bgColor: "#FFD84D",
          circleColor: "#FFCC00"
        },
        {
          key: "renting",
          icon: require("@/assets/car-renting.png"),
          total: 0,
          text: "Renting",
          bgColor: "#F3EED2",
          circleColor: "#E8DEB0",
          is_click: true
        },
        {
          key: "available",
          icon: require("@/assets/car-available.png"),
          total: 0,
          text: "Available",
          bgColor: "#F6E9EE",
          circleColor: "#FFFFFF",
          is_click: true
        },
        {
          key: "ready",
          icon: require("@/assets/car-ready.png"),
          total: 0,
          text: "Ready",
          bgColor: "#E3F4EF",
          circleColor: "#CDEDE3",
          is_click: true
        },
        {
          key: "fixing",
          icon: require("@/assets/car-fixing.png"),
          total: 0,
          text: "Fixing",
          bgColor: "#E6F3FA",
          circleColor: "#D3EBF6",
          is_click: true
        },
        {
          key: "accident",
          icon: require("@/assets/car-accident.png"),
          total: 0,
          text: "Accident",
          bgColor: "#F1F1F1",
          circleColor: "#E0E0E0",
          is_click: true
        }
      ]
    };
  },
  async created() {
    this.getDataCountDashBoardHeader();//
    await this.onLazyEvent();
    var year = new Date().getFullYear()
    var yearRange = (year - 10) + ':' + (year + 90);
    var yearDOB = (year - 100) + ':' + year;
    this.yearRange = yearRange + '';
    this.yearDOB = yearDOB + '';
    this.test = this.tableData;

    var arr_role_clubs = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_DASHBOARD);
    if (arr_role_clubs.indexOf(this.$constants.ROLE.VIEW) < 0) this.view_club = false;
    else this.view_club = true;

    
  },
  mounted() {
    this.setDefaultDateRange();
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };

    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        this.firstRecordIndex = this.lazyParams.first;
      }
    }

    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    formatNoteDate(v) {
      if (!v) return '-';
      const d = new Date(v);
      if (isNaN(d.getTime())) return '-';
      return d.toLocaleString('vi-VN', {
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    // ✅ note methods (thêm mới)
    toggleEditNote(r) {
      if (!r || !r.id) return;

      if (this.editingNoteId === r.id) {
        this.editingNoteId = null;
        return;
      }

      this.editingNoteId = r.id;

      if (this.noteDrafts[r.id] === undefined) {
        this.$set(this.noteDrafts, r.id, "");
      }
    },

    cancelEditNote(r) {
      if (!r || !r.id) return;
      this.editingNoteId = null;
    },

    getCarIdForNote(r) {
      return r?.car_id || r?.renting_car_id || r?.id || null;
    },

    async submitNote(r) {
      const note = (this.noteDrafts?.[r.id] || "").trim();
      if (!note) return;

      const carId = this.getCarIdForNote(r);
      if (!carId) return;

      this.savingNote = true;
      try {
        
        const apiUrl = "/api_admin/order/add_log";
        const dataRequest = {
          object_id: carId,
          type: "car_for_rent",
          note,
        };

        const response = await this.$CoreService.sendApi(apiUrl, dataRequest);
        console.log(response);

        const raw = response?.data || {};
        r.latest_note = raw?.latest_note || raw?.data?.latest_note || note;
        r.latest_note_at = raw?.latest_note_at || raw?.data?.latest_note_at || new Date().toISOString();

        this.editingNoteId = null;
        this.$set(this.noteDrafts, r.id, "");
      } catch (err) {
        console.log(err);
        if (this.$toast) {
          this.$toast.add({
            severity: "error",
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000,
          });
        }
      } finally {
        this.savingNote = false;
      }
    },

    async callApiUpdateDashBoard() {
      await this.onLazyEvent();
    },

    // ✅ click 3 trạng thái -> mở dialog + call api lấy biển số
    async onClickStatsCard(payload) {
      try {
        const key = payload?.key || payload?.item?.key;

        // chỉ xử lý 3 key
        if (!["renting","available","ready", "fixing", "accident"].includes(key)) return;

        const statusMap = {
          renting: "RENTING_RENT",
          available: "AVAILABLE_RENT",
          ready: "READY_RENT",
          fixing: "FIXING_RENT",
          accident: "ACCIDENT_RENT"
        };

        const titleMap = {
          renting: "Renting Cars",
          available: "Available Cars",
          ready: "Ready for Use",
          fixing: "Under Repair",
          accident: "Accident-Damaged Cars"
        };

        this.dialog_plate_title = titleMap[key] || "Car list";
        this.showDialogPlate = true;
        this.loadingPlate = true;

        // ✅ reset note UI khi mở dialog (thêm mới)
        this.editingNoteId = null;
        this.noteDrafts = {};

        this.plateList = [];

        const headers = {
          Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
          Timezone: moment.tz.guess()
        };

        const body = {
          status: statusMap[key],
          // gửi kèm date range nếu BE muốn lọc theo created_at (optional)
          date_from_to: this.obj_data?.effective_date_range || null
        };

        // ✅ API mới (BE viết ở dưới)
        const res = await ApiRepository.post(
          "/_api/dashboard/get_list_car_for_rent_by_status",
          body,
          { headers }
        );

        // Hỗ trợ nhiều format response để khỏi lỗi
        const raw = res?.data || {};
        const list =
          raw?.list_data ||
          raw?.data ||
          raw?.data?.list_data ||
          raw?.data?.data ||
          [];

        this.plateList = Array.isArray(list) ? list : [];
      } catch (err) {
        console.log(err);
        this.plateList = [];
        if (this.$toast) {
          this.$toast.add({
            severity: "error",
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000,
          });
        }
      } finally {
        this.loadingPlate = false;
      }
    },

    formatIncoming(value) {
      return value = '$' + parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '$0.00';
    },
    onRowSelect(event) {
      this.$emit('onRowSelect', event.data);
    },
    setDefaultDateRange() {
      const startOfMonth = moment().startOf('month').toDate();
      const endOfMonth = moment().endOf('month').toDate();
      this.obj_data.effective_date_range = [startOfMonth, endOfMonth];
    },
    redirectListClub(data, e) {
      let clickedElId = e.target.id
      if (clickedElId === 'list-users-clubs') {
        var id = data.id;
        var path = `/admin/list-users_clubs/${id}`;
        this.$router.push({ path: path })
      }
    },
    callbackCustomUrl(c, data) {
      var text = ''
      switch (c.key) {
        case 'club_html':
          if (data.view_users_clubs_expiration_aggregate && data.view_users_clubs_expiration_aggregate.aggregate) {
            var count_club = data.view_users_clubs_expiration_aggregate.aggregate.count
            if (this.view_club == true) {
              text = '<a class="txt-link" id="list-users-clubs" :data-id="' + data.id + '">' + count_club + '</a>';
            } else {
              text = count_club;
            }
          } else {
            text = 0;
          }
          break;
        default:
          break;
      }
      return text;
    },
    select_date(event, col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", { data: this.filters[col_name], col: col_name });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") return "Custom";
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") return "Image";
          if (col.inputOptions?.mode == "selection") return "Select";
          if (col.inputOptions?.mode == "currency") return "Currency";
          if (col.inputOptions?.mode == 'icon') return "Icon";
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") return "Currency";
          else if (col.inputOptions?.mode == "percentage") return "Percentage";
          else return "Number";
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange) f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) { return col.key; },
    getHeaderStyle(col) {
      var style = "text-align:center;";
      if (col.width) style += "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style += "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style += "width: 6em;";
      return style;
    },
    getBodyStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "text-align:center; width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Date" && row[col.key]) value = moment.tz(row[col.key], this.time_zone_local).format("LL");
      else if (col.type == "Datetime" && row[col.key]) value = moment.tz(row[col.key], this.time_zone_local).format("ll HH:mm");
      else if (col.type == "CustomDate" && row[col.key]) value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      else if (col.type == "Hour" && row[col.key]) value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm");
      else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) lists = col.options;
        else if (col.models !== undefined && this.options[col.key] !== undefined) lists = this.options[col.key];
        if (lists && lists?.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult)?.length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key]?.length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter(a => a.value === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered)?.length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) filterMatch = col.filter.match;
      return filterMatch;
    },
    getSortable(col) { return col.sortable && col.sortable == true ? true : false; },
    getIcon(iconName) { return `pi pi-${iconName}`; },
    getDisabled(disabled = false) { return disabled; },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", { originalEvent: event, action: action, key: key, data: rowData, lazyParams: this.lazyParams });
    },
    getClass(type) {
      switch (type) {
        case "add": return "p-button-add";
        case "delete": return "p-button-danger";
        case "edit": return "p-button-edit";
        case "adddebt": return "p-button-edit"
        case "add-Debt": return "p-button-add";
        case "editcustom": return "p-button-edit"
        case "addcustom": return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", { style: "currency", currency: "VND" });
    },
    callbackDataSelect(c, data) {
      var text = "";
      switch (c.key) {
        case 'active':
          if (data.active == true) text = `<i style="color: green" class="pi pi-check icon"></i>`;
          else text = `<i style="color: red" class="pi pi-times icon"></i>`;
          break;
        default:
      }
      return text;
    },

    async dataList(lazyParams) {
      var offset = lazyParams.first;
      var limit = lazyParams.rows;
      var where = {}
      var filters = lazyParams.filters;
      var dataRequest = { offset: offset, limit: limit };

      if (filters) {
        for (const [key, value] of Object.entries(filters)) {
          if (key == 'total_own_property_key') {
            if (!this.$commonFuction.isEmpty(value.value)) {
              if (this.$commonFuction.isNumeric(value.value) == true) dataRequest[key] = value;
            }
          } else dataRequest[key] = value;

          if (!this.$commonFuction.isEmpty(value.value)) {
            if (value.type_input == 'input') {
              if (key == 'fullname') where['plain_fullname'] = { _like: "%" + this.$commonFuction.SkipVN(value.value) + "%" };
              else where[key] = { _like: "%" + value.value + "%" };
            } else if (value.type_input == 'select') {
              if (key == 'name_group_filter') where['group_id'] = { _eq: value.value };
            }
          }
        }
      }

      var listData = [];
      var total = 0;
      var total_goin = [];
      this.$emit("emit_filter", dataRequest);
      this.data_filter = dataRequest;

      var list_action_detail = await this.getDataTablePaymentHistory();
      listData = list_action_detail["data"]["data"];
      total = list_action_detail["data"]["totalItem"];
      total_goin = list_action_detail["data"]["totalgoing"];

      return { listData, total, total_goin };
    },

    formatDateRange(dateArray) {
      return dateArray.map(date => new Date(date).toISOString().split('T')[0]).join(',');
    },

    async getDataTablePaymentHistory() {
      var dataRequest = this.data_filter;
      const headers = { "Authorization": "Bearer " + (await this.$AuthenticationApp.getToken()) };
      const dateArray = this.obj_data.effective_date_range;
      const response = await ApiRepository.post(
        '/_api/dashboard/get_data_table_payment_history_admin_dashboard',
        { date_from_to: dateArray, dataRequest: dataRequest },
        { headers }
      );
      return response.data;
    },

    async getDataCountDashBoardHeader() {
      const headers = { Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()) };
      const dateArray = this.obj_data.effective_date_range;

      const response = await ApiRepository.post(
        "/_api/dashboard/get_data_dashboard",
        { date_from_to: dateArray },
        { headers }
      );

      const data = response?.data || {};

      for (let i = 0; i < this.stats.length; i++) {
        const k = this.stats[i]?.key;
        if (k === "total") this.stats[i].total = parseInt(data.total_car || 0);
        else if (k === "renting") this.stats[i].total = parseInt(data.renting || 0);
        else if (k === "available") this.stats[i].total = parseInt(data.available || 0);
        else if (k === "ready") this.stats[i].total = parseInt(data.ready || 0);
        else if (k === "fixing") this.stats[i].total = parseInt(data.fixing || 0);
        else if (k === "accident") this.stats[i].total = parseInt(data.accident || 0);
      }

      this.total_car = parseInt(data.total_car || 0);
      this.total_renting_car = parseInt(data.renting || 0);
    },

    async onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      this.loading = true;
      var that = this;
      this.dataList(this.lazyParams).then(async data => {
        if (data?.listData?.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }

        this.incoming = data.total_goin?.total_incoming ?? 0;
        this.outgoing = data.total_goin?.total_outgoing ?? 0;

        var stt = this.lazyParams.first;
        for (var i = 0; i < data.listData?.length; i++) {
          var itemData = data.listData[i];
          stt++;
          data.listData[i].stt = stt;
          data.listData[i].updated_at = this.formatDate(itemData.updated_at) ?? '';
          data.listData[i].amount = '$' + parseFloat(data.listData[i].amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '$0.00';
          if (data.listData[i].total_payment) data.listData[i].total_payment = '$' + parseFloat(data.listData[i].total_payment).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '$0.00';
          else data.listData[i].total_payment = '$0.00';

          data.listData[i].updated_by_key = itemData.updated_by_name ?? '';
          if (data.listData[i].type == 6) data.listData[i].type = 'Outgoing';
          else data.listData[i].type = 'Incoming';

          if (data.listData[i].status === 'Success') data.listData[i].status = 'Paid';

          if (data?.listData?.length > 0) {
            for (var j = 0; j < data.listData.length; j++) {
              var itemDataTable = data.listData[j];
              if (itemData.id == itemDataTable.id) {
                data.listData[i].code = itemDataTable?.code;
                data.listData[i].rental_order_id = itemDataTable?.rental_order_code;
                break;
              }
            }
          }
        }

        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },

    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },

    async onFilter(event, type_input, key) {
      this.tableData = this.test;
      if (type_input == "DateRange") {
        if (this.filters[key] !== null && this.filters[key][1] == null) return false;
      }
      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input, key, this.filters);
      this.lazyParams.first = 0;
      this.onLazyEvent()
    },
  }
};
</script>

<style lang="scss">
.icon-down-up { height: 21px; width: 21px; opacity: 1; margin-right: 5px; }
.up-and-down-payment { display: flex; justify-content: left; align-items: center; padding-bottom: 20px; padding-top: 20px ; }
.incoming-down, .outcoming-up { margin-right: 100px; display: flex; align-items: center; }
.incoming-down, .outcoming-up { height: 21px; text-align: left; font: normal normal normal 16px/21px Segoe UI; letter-spacing: 0px; color: #666666; opacity: 1; }
.amount-incoming { margin-left: 10px; height: 21px; font-size: 16px; text-align: left; font: normal normal bold 16px/21px Segoe UI; letter-spacing: 0px; color: #32A952; opacity: 1; }
.amount-outgoing { margin-left: 10px; height: 21px; font-size: 16px; text-align: left; font: normal normal bold 16px/21px Segoe UI; letter-spacing: 0px; color: #F5564E; opacity: 1; }
.p-paginator-bottom { padding: 0 !important; }
.p-inputtext { width: 100%; }
.p-button-label { color: white; }
.payment-history-header {
  height: 32px;
  text-align: left;
  font: normal normal bold 24px/32px Segoe UI;
  letter-spacing: 0px;
  color: #1D3118;
  text-transform: uppercase;
  opacity: 1;
}
</style>
<style lang="css">
:root {
  --accent: #caa200;
  --bg: #f6f7fb;
  --card: #ffffff;
  --text: #111827;
  --muted: rgba(17, 24, 39, 0.58);
  --border: rgba(17, 24, 39, 0.10);
  --shadow-sm: 0 2px 10px rgba(17, 24, 39, 0.06);
  --shadow-md: 0 12px 28px rgba(17, 24, 39, 0.12);
  --ok: #16a34a;
}

/* Wrapper */
.car-wrap { padding: 12px; }

.car-loading,
.car-empty {
  padding: 14px 12px;
  border-radius: 12px;
  background: var(--bg);
  border: 1px solid rgba(17, 24, 39, 0.06);
  color: var(--muted);
}

/* List container */
.car-list {
  max-height: 500px;
  overflow: auto;
  padding: 12px;
  background: var(--bg);
  border-radius: 14px;
  border: 1px solid rgba(17, 24, 39, 0.06);

  scrollbar-width: thin;
  scrollbar-color: rgba(17, 24, 39, 0.22) transparent;
}

.car-list::-webkit-scrollbar { width: 10px; }
.car-list::-webkit-scrollbar-thumb {
  background: rgba(17, 24, 39, 0.22);
  border-radius: 999px;
  border: 3px solid transparent;
  background-clip: content-box;
}
.car-list::-webkit-scrollbar-thumb:hover { background: rgba(17, 24, 39, 0.32); }

/* =========================
   ITEM: GRID (align perfect)
   ========================= */
.car-item {
  display: grid;
  grid-template-columns: 260px 1fr 28px; /* left | right | action */
  gap: 16px;
  align-items: stretch;

  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: var(--shadow-sm);
  transition: transform 0.12s ease, box-shadow 0.12s ease, border-color 0.12s ease;
}

.car-item:hover {
  transform: translateY(-1px);
  border-color: rgba(202, 162, 0, 0.35);
  box-shadow: var(--shadow-md);
}

/* highlight has note */
.car-item.has-note {
  background: linear-gradient(180deg, rgba(202, 162, 0, 0.08), #fff 60%);
  border-color: rgba(202, 162, 0, 0.25);
  position: relative;
}
.car-item.has-note::before {
  content: "";
  position: absolute;
  left: 0;
  top: 14px;
  bottom: 14px;
  width: 4px;
  border-radius: 999px;
  background: var(--accent);
}

/* LEFT column */
.car-left {
  display: flex;
  align-items: stretch; /* QUAN TRỌNG: stretch thay vì center */
  justify-content: center;
}

/* License plate box (full height of item) */
.lp {
  width: 100%;
  height: 100%;
  min-height: 74px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  border-radius: 12px;
  border: 2px solid rgba(17, 24, 39, 0.18);
  background: linear-gradient(180deg, #ffffff, #f3f4f6);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
  padding: 10px 12px;
}

/* Dots */
.lp-dot {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: rgba(17, 24, 39, 0.22);
  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.06);
  flex: 0 0 auto;
}
.car-item.has-note .lp-dot {
  background: var(--ok);
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.12);
}

.lp-text {
  font-weight: 900;
  font-size: 18px;
  letter-spacing: 1px;
  color: #0f172a;
  text-transform: uppercase;

  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* RIGHT column:
   row-gap thay cho margin-top để không bị tụt */
.car-right {
  display: grid;
  grid-template-rows: 28px 1fr; /* header fixed height => đều */
  row-gap: 10px;
  align-content: stretch;
  min-width: 0;
}

/* Header fixed-height & align */
.car-right-header {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 28px; /* cố định => khỏi lệch */
}

.car-right-title {
  font-size: 12px;
  font-weight: 800;
  color: rgba(17, 24, 39, 0.55);
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.car-date {
  margin-left: auto;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  color: rgba(17, 24, 39, 0.70);
  background: rgba(17, 24, 39, 0.05);
  border: 1px solid rgba(17, 24, 39, 0.08);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.car-date.empty {
  color: rgba(17, 24, 39, 0.35);
  background: rgba(17, 24, 39, 0.03);
  border-color: rgba(17, 24, 39, 0.06);
}

/* NOTE BOX: bỏ margin-top hoàn toàn */
.car-note {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 12px;

  background: rgba(17, 24, 39, 0.03);
  border: 1px dashed rgba(17, 24, 39, 0.14);

  font-size: 14px;
  color: rgba(17, 24, 39, 0.92);
  line-height: 1.45;

  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.car-note.empty {
  color: rgba(17, 24, 39, 0.38);
}

/* ACTION */
.car-action {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2px;
  color: rgba(17, 24, 39, 0.35);
  user-select: none;
}
.car-action .dot {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  cursor: pointer;
}
.car-action .dot:hover {
  background: rgba(17, 24, 39, 0.06);
  color: rgba(17, 24, 39, 0.70);
}

/* ✅ (thêm mới) style nút + block nhập ghi chú */
.car-btn-note{
  margin-left: 8px;
  padding: 4px 10px !important;
}
.car-btn-note .p-button-label{
  color: rgba(17, 24, 39, 0.80) !important;
}

.car-add-note{
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(202, 162, 0, 0.06);
  border: 1px solid rgba(202, 162, 0, 0.18);
}
.car-add-note-title{
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: rgba(17, 24, 39, 0.55);
}
.car-add-note-body{ margin-top: 8px; }
.car-add-note-textarea{ width: 100%; }
.car-add-note-btns{
  display:flex;
  gap:10px;
  margin-top: 8px;
  justify-content:flex-end;
}

/* Responsive */
@media (max-width: 720px) {
  .car-item {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .car-action {
    justify-content: flex-end;
    padding-top: 0;
  }
  .lp { min-height: 56px; }
  .lp-text { font-size: 17px; }
}
/* ✅ Beautify "Ghi chú" button (per-item) */
.car-btn-note {
  height: 28px !important;
  padding: 0 10px !important;
  border-radius: 999px !important;

  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;

  border: 1px solid rgba(202, 162, 0, 0.55) !important;
  background: rgba(202, 162, 0, 0.08) !important;
  box-shadow: 0 2px 8px rgba(17, 24, 39, 0.06) !important;

  white-space: nowrap !important; /* chống bể chữ */
  min-width: 86px;               /* đủ cho "Ghi chú" */
}

.car-btn-note .p-button-icon {
  font-size: 12px !important;
  margin: 0 !important;
  color: rgba(202, 162, 0, 0.95) !important;
}

.car-btn-note .p-button-label {
  font-size: 12px !important;
  font-weight: 800 !important;
  letter-spacing: 0.2px !important;
  color: rgba(17, 24, 39, 0.78) !important;
  line-height: 1 !important;
}

/* hover / active */
.car-btn-note:hover {
  background: rgba(202, 162, 0, 0.14) !important;
  border-color: rgba(202, 162, 0, 0.75) !important;
  transform: translateY(-1px);
}

.car-btn-note:active {
  transform: translateY(0);
  box-shadow: none !important;
}

/* nếu bị theme primevue ép width full */
.car-right-header .car-btn-note {
  flex: 0 0 auto !important;
}

</style>
